export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_MULTI_FILE = "UPLOAD_MULTI_FILE";
export const API_FAIL = "FILE_API_FAIL";

export const POST_IPFS_FILE = "POST_IPFS_FILE";
export const UPLOAD_ART = "UPLOAD_ART";
